"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULED_LIMIT_SPREADSHEET_COLUMN_ORDER = exports.ScheduledLimitStatusReason = exports.ScheduledLimitStatus = void 0;
var ScheduledLimitStatus;
(function (ScheduledLimitStatus) {
    ScheduledLimitStatus["ACTIVE"] = "ACTIVE";
    ScheduledLimitStatus["INACTIVE"] = "INACTIVE";
})(ScheduledLimitStatus = exports.ScheduledLimitStatus || (exports.ScheduledLimitStatus = {}));
var ScheduledLimitStatusReason;
(function (ScheduledLimitStatusReason) {
    ScheduledLimitStatusReason["CREATED"] = "CREATED";
    ScheduledLimitStatusReason["ARCHIVED"] = "ARCHIVED";
    ScheduledLimitStatusReason["ACTIVATED"] = "ACTIVATED";
    ScheduledLimitStatusReason["REPLACED"] = "REPLACED";
})(ScheduledLimitStatusReason = exports.ScheduledLimitStatusReason || (exports.ScheduledLimitStatusReason = {}));
exports.SCHEDULED_LIMIT_SPREADSHEET_COLUMN_ORDER = [
    'limit',
    'coinsurance',
    'deductible',
    'minimumDeductible',
    'percentageOfLoss',
    'comprehensive',
    'collision',
    'waitingPeriodHours',
    'excludedOrIncluded',
    'estimatedAnnualRemuneration',
    'baseRate',
    'netRate',
];
//# sourceMappingURL=scheduled-limit.js.map